import React from 'react';
import { CTAButton } from './CTAButton';
import { Zap } from 'lucide-react';
export function ClosingSection() {
  return <section id="comprar" className="py-32 bg-black relative overflow-hidden flex flex-col items-center justify-center text-center" data-id="element-38">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-red-900/20" data-id="element-39" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-500 to-transparent" data-id="element-40" />

      <div className="container mx-auto px-4 relative z-10 max-w-4xl" data-id="element-41">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-8 uppercase leading-tight" data-id="element-42">
          Seguir perdiendo también es{' '}
          <span className="text-red-500" data-id="element-43">una decisión</span>.
        </h2>

        <div className="space-y-6 mb-12" data-id="element-44">
          <p className="text-2xl text-slate-300" data-id="element-45">
            Podés seguir jugando como todos. <br data-id="element-46" />
            <span className="text-white font-bold" data-id="element-47">
              O podés empezar a jugar con estrategia.
            </span>
          </p>

          <p className="text-xl text-slate-400" data-id="element-48">
            La diferencia entre promedio y dominante no es talento. <br data-id="element-49" />
            <span className="text-blue-400 font-bold text-2xl uppercase tracking-wider" data-id="element-50">
              Es mentalidad + sistema + ejecución.
            </span>
          </p>
        </div>

        {/* Pricing Block */}
        <div className="relative max-w-md mx-auto mb-12" data-id="element-51">
          <div className="relative bg-slate-950 border border-slate-800 p-8 md:p-10 rounded-xl shadow-2xl" data-id="element-52">
            {/* Discount Badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-red-600 to-orange-500 text-white font-black text-sm px-4 py-2 rounded-lg shadow-lg shadow-red-900/40 rotate-3 uppercase tracking-wider flex items-center gap-1.5" data-id="element-53">
              <Zap className="w-4 h-4" data-id="element-54" />
              67% OFF
            </div>

            <div className="text-center space-y-6" data-id="element-55">
              <span className="text-blue-400 font-bold tracking-widest uppercase text-sm" data-id="element-56">
                Precio Especial
              </span>

              {/* Old Price */}
              <div data-id="element-57">
                <span className="text-slate-500 line-through text-2xl font-medium" data-id="element-58">
                  $30.000,00 ARS
                </span>
              </div>

              {/* Current Price */}
              <div className="flex items-baseline justify-center gap-1" data-id="element-59">
                <span className="text-5xl md:text-6xl font-black text-white leading-none" data-id="element-60">
                  $9.990
                </span>
                <span className="text-2xl font-bold text-slate-400" data-id="element-61">,00</span>
                <span className="text-lg font-bold text-slate-500 ml-1" data-id="element-62">
                  ARS
                </span>
              </div>

              {/* Savings callout */}
              <div className="inline-block bg-green-900/30 border border-green-500/30 rounded-full px-4 py-1.5" data-id="element-63">
                <span className="text-green-400 font-bold text-sm" data-id="element-64">
                  Ahorrás $20.010,00
                </span>
              </div>

              {/* Divider */}
              <div className="border-t border-slate-800 pt-6" data-id="element-65">
                <p className="text-slate-400 text-sm" data-id="element-66">
                  Acceso inmediato · Pago único · Sin suscripción
                </p>
              </div>
            </div>
          </div>
        </div>

        <CTAButton variant="primary" className="text-2xl py-6 px-12" subtext="Acceso inmediato. Empezás hoy." onClick={() => window.open('https://juegospro369.online/cart/52665779487087:1', '_blank')} data-id="element-67">
          QUIERO PASAR A NIVEL DOMINANTE
        </CTAButton>

        <div className="mt-12 flex items-center justify-center gap-8 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-68">
          {/* Trust badges placeholders */}
          <div className="text-slate-500 text-sm font-bold uppercase tracking-widest" data-id="element-69">
            Pago Seguro
          </div>
          <div className="text-slate-500 text-sm font-bold uppercase tracking-widest" data-id="element-70">
            Acceso Instantáneo
          </div>
          <div className="text-slate-500 text-sm font-bold uppercase tracking-widest" data-id="element-71">
            Garantía de Calidad
          </div>
        </div>
      </div>
    </section>;
}